module.exports = __webpack_public_path__ + "static/brand-vdwall-851e725708023f03da510b56ddd3cced.png";